import { stdObject } from "../data/types/stdObject";
import { sendData } from "./sendData";

export const callServicesRecords = async (code: string, logoutAction: any) => {
  const payloadCallServicesRecords = { code };
  console.log("payloadCallServicesRecords", payloadCallServicesRecords);

  const responseCallServicesRecords: stdObject = await sendData({
    endPoint: "callCustomerServiceRecords",
    payload: payloadCallServicesRecords,
    logoutAction,
  });
  console.log("responseCallServicesRecords", responseCallServicesRecords);
  const { success, list, fields } = responseCallServicesRecords;
  return success ? { list, fields } : { list: [] };
};
